<template>
  <b-card title="">
    <h4 class="text-primary font-weight-bold mb-2">รายงานคิวที่จอง</h4>

    <b-row>
      <b-col md="6">
        <b-form-group label="alCode" label-for="alCode">
          <b-form-input id="alCode" v-model="formUser.alCode" placeholder="alCode" />
        </b-form-group>
      </b-col>
      <b-col md="6">
        <b-form-group>
          <h5 class="font-weight-bold">ด่านชายแดน</h5>
          <b-form-select v-model="selectedBorder" :options="options"
            :class="{ 'is-invalid': showError && !selectedBorder }" />
          <div class="invalid-feedback">กรุณาเลือกด่านชายแดน</div>
        </b-form-group>
      </b-col>
      <b-col md="6">
        <b-form-group>
          <h5 class="font-weight-bold">เลือกวันที่เริ่มต้นลงทะเบียน</h5>
          <flat-pickr v-model="startDate" class="form-control" :config="DateConfig" />
        </b-form-group>
      </b-col>

      <b-col md="6">
        <b-form-group>
          <h5 class="font-weight-bold">เลือกวันที่สิ้นสุดลงทะเบียน</h5>
          <flat-pickr v-model="endDate" class="form-control" :config="DateConfig" />
        </b-form-group>
      </b-col>
      <b-col md="6"></b-col>
      <b-col md="6"></b-col>
      <!-- <b-col md="6">
        <b-form-group>
          <h5 class="font-weight-bold">วันที่เข้าประเทศไทย</h5>
          <flat-pickr
            v-model="in_dateDefault"
            class="form-control"
            :class="{ 'is-invalid': showError && !in_dateDefault }"
            :config="{ dateFormat: 'd-m-Y' }"
          />
          <div class="invalid-feedback">วันที่เข้าประเทศไทย</div>
        </b-form-group>
      </b-col> -->
      <b-col md="6">
        <br />
        <b-button variant="primary" @click.prevent="Getdata"> ค้นหา </b-button>
      </b-col>
      <br />
      <b-col md="6"></b-col>
      <b-col md="6">
        <br />
        <h4 class="text-primary font-weight-bold mb-2">
          ตารางแสดงรายการคิวที่จอง
        </h4>
      </b-col>
      <b-col md="6"></b-col>
      <b-col md="6" sm="4" class="my-1">
        <b-form-group class="mb-0">
          <label class="d-inline-block text-sm-left mr-50">จำนวนต่อหน้า</label>
          <b-form-select id="perPageSelect" v-model="perPage" size="sm" :options="pageOptions" class="w-50"
            @change="handleItemsPerPageChange" />
        </b-form-group>
      </b-col>
      <b-col md="6" class="my-1">
        <b-form-group label="ค้นหา" label-cols-sm="3" label-align-sm="right" label-size="sm" label-for="filterInput"
          class="mb-0">
          <b-input-group size="sm">
            <b-form-input id="filterInput" v-model="filter" type="search" placeholder="พิมพ์เพื่อค้นหา" />
            <b-input-group-append>
              <b-button :disabled="!filter" @click="filter = ''">
                ยกเลิก
              </b-button>
            </b-input-group-append>
          </b-input-group>
        </b-form-group>
      </b-col>
    </b-row>

    <b-col cols="12">
      <b-table striped hover responsive :current-page="currentPage" :items="items" :fields="fields"
        :sort-by.sync="sortBy" :sort-desc.sync="sortDesc" :sort-direction="sortDirection" :filter="filter"
        :filter-included-fields="filterOn" @filtered="onFiltered">
        <!-- 👇 CUSTOM ACTION COLUMN -->
        <template #cell(action)="props">
          <b-button variant="outline-primary" size="sm" @click="handlePrint(props.item)" title="ปริ้น">
            <feather-icon icon="PrinterIcon" />
          </b-button>
        </template>
      </b-table>
    </b-col>
    <!-- Pagination -->
    <b-card v-show="true" class="p-0 mb-1" no-body>
      <b-nav class="navbar d-flex justify-content-between bd-highlight flex-wrap">
        <div>
          Showing {{ (currentPage - 1) * perPage + 1 }} to
          {{ Math.min(currentPage * perPage, totalRows) }}
          of {{ totalRows }} entries
        </div>
        <!-- {{currentPage}} -->
        <div class="bd-highlight">
          <b-pagination v-model="currentPage" :total-rows="totalRows" :per-page="perPage" @input="handlePageChange"
            class="mb-0" first-text="First" prev-text="Prev" next-text="Next" last-text="Last" align="left"
            hide-goto-end-buttons />
        </div>
      </b-nav>
    </b-card>
  </b-card>
</template>

<script>
import {
  BTable,
  BAvatar,
  BBadge,
  BRow,
  BCol,
  BFormGroup,
  BFormSelect,
  BPagination,
  BInputGroup,
  BFormInput,
  BInputGroupAppend,
  BButton,
} from "bootstrap-vue";
import { BCard, BCardText } from "bootstrap-vue";
import flatPickr from "vue-flatpickr-component";
import "flatpickr/dist/flatpickr.css";
import store from "@/store/index";
import API from "@/connect/config";
import axios from "axios";
import { BNav } from "bootstrap-vue";
import jsPDF from 'jspdf';
import autoTable from 'jspdf-autotable';
import QRCode from "qrcode";

export default {
  components: {
    BTable,
    BAvatar,
    BBadge,
    BRow,
    BCard,
    BCardText,
    BCol,
    BFormGroup,
    BFormSelect,
    BPagination,
    BInputGroup,
    BFormInput,
    BInputGroupAppend,
    BButton,
    BNav,
    flatPickr,
  },
  data() {
    return {
      perPage: 100,
      pageOptions: [25, 50, 100],
      totalPage: 0,
      totalRows: 0,
      currentPage: 1,
      sortBy: "",
      sortDesc: false,
      sortDirection: "asc",
      isBusy: false,
      items: [],
      filter: null,
      filterOn: [],
      selectedBorder: null, // ✅ ค่า default (ตรงกับ value: null)
      fields: [
        { key: "select", label: "", sortable: false },
        { key: "no", label: "ลำดับที่" },
        { key: "alcode", label: "เลขพาสปอร์ต/เลขที่ประจำตัว13หลัก" },
        { key: "prefix", label: "คำนำหน้า" },
        { key: "firstname", label: "ชื่อ" },
        { key: "lastname", label: "นามสกุล" },
        { key: "gender", label: "เพศ" },
        { key: "cardSerialNumber", label: "card SerialNumber" },
        { key: "registeredEntryDateFormatted", label: "วันที่เดินทางออกประเทศไทย" },
        { key: "createdAtFormatted", label: "วันที่ลงทะเบียน" },
        { key: "action", label: "Print" }, // ✅ เพิ่มตรงนี้
      ],
      in_dateDefault: null, // new Date(), // หรือใช้ null, หรือ new Date() ก็ได้
      out_dateDefault: new Date(), //new Date(), // หรือใช้ null, หรือ new Date() ก็ได้
      showError: false,
      outDateConfig: {
        dateFormat: "d-m-Y",
        // onChange: this.handleOutDateChange.bind(this),
      },
      DateConfig: {
        dateFormat: "Y-m-d", // format ที่ใช้ส่งจริง
        altInput: true,
        altFormat: "d-m-Y",  // format ที่แสดงผล
      },
      options: [{ value: null, text: "-- เลือกด่านชายแดน --" }],
      startDate: new Date(),
      endDate: new Date(),
      formUser: {
        reqcode: "",
        alCode: "",
      },
    };
  },
  computed: {
    sortOptions() {
      // Create an options list from our fields
      return this.fields
        .filter((f) => f.sortable)
        .map((f) => ({ text: f.label, value: f.key }));
    },
  },
  created() {
    // this.getDataTable();
  },
  mounted() {
    this.getDataSelectOption();
    // Set the initial number of items
    //this.totalRows = this.items.length;
    if (this.items && this.items.length) {
      console.log(this.items.length);
    } else {
      console.log("ยังไม่มีข้อมูล items");
    }
  },
  methods: {
    validate() {
      this.showError = !this.out_dateDefault;

      if (this.showError) {
        // หยุดการ submit
        return;
      }

      return true;
    },
    info(item, index, button) {
      this.infoModal.title = `Row index: ${index}`;
      this.infoModal.content = JSON.stringify(item, null, 2);
      this.$root.$emit("bv::show::modal", this.infoModal.id, button);
    },
    resetInfoModal() {
      this.infoModal.title = "";
      this.infoModal.content = "";
    },
    onFiltered(filteredItems) {
      console.log(filteredItems);
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },
    async handlePrint(item) {
      // ตัวอย่างการปริ้นหรือ export PDF เฉพาะรายการนี้
      console.log("พิมพ์ข้อมูล:", item);
      const doc = new jsPDF();

      doc.setFontSize(16);
      // doc.text("ใบยืนยันการจองคิว", 20, 20);

      const data = [
        //  ["เลขลำดับ", item.no],
        ["Name", `${item.prefix} ${item.firstname} ${item.lastname}`],
        ["ID Card No.", item.alcode],
        ["Sex", item.gender],
        ["Nationality", item.Nationality],
        ["Appointment Date", item.registeredEntryDateFormatted],
        ["Card SerialNumber", item.cardSerialNumber],
        // ["Shift", item.shift],
        // ["StationName", item.StationName],
      ];

      autoTable(doc, {
        startY: 30,
        // head: [["หัวข้อ", "ข้อมูล"]],
        body: data,
        // theme: "grid",
      });
      autoTable(doc, {
        startY: 30,
        // head: [["หัวข้อ", "ข้อมูล"]],
        body: data,
        // theme: "grid",
      });
      

     const { VUE_APP_FONTEND_URL } = process.env

      // สร้าง URL สำหรับ QR https://borderreg.wacsvdev.com/
      const url = `${VUE_APP_FONTEND_URL}booking?alcode=${item.alcode}&createdAt=${item.formatDateFromYYYYMMDD_pdf.replace(/-/g, '')}`;

      // แปลง URL เป็น Base64 QR Code

      try {
        const qrDataUrl = await QRCode.toDataURL(url);
        const qrSize = 50;
        const pageWidth = doc.internal.pageSize.getWidth();
        const qrX = (pageWidth - qrSize) / 2;
        const qrY = 100;
        doc.addImage(qrDataUrl, "PNG", qrX, qrY, qrSize, qrSize);
        doc.setFontSize(10);
        doc.text(`alcode: ${item.alcode}`, pageWidth / 2, qrY + qrSize + 10, { align: "center" });
      } catch (err) {
        console.error("❌ QR Code Error:", err);
      }

      doc.save(`Queue_${item.alcode}.pdf`);
      // สามารถใช้ window.print() หรือ PDF generator เช่น jsPDF, html2pdf
    }, async getDatauserFromCompany(_userId) {
      try {
        const jwt = JSON.parse(localStorage.getItem("company_jwt"));
        const params = {
          companyId: jwt.companyId,
          userId: _userId,
        };
        console.log("Request Params", params);
        const res = await axios.get(`${API}userFromCompany`, {
          params,
          headers: {
            Authorization: await store.dispatch("getAuthorization"),
          },
        });
        console.log("API Response", res.data)
        return res.data.message.data;
      } catch (err) {
        console.error("❌ Error:", err.response?.data || err.message);
      } finally {
        this.isBusy = false;
      }

      return;

    },
    formatDateFromYYYYMMDD(dateStr) {
      if (!dateStr || dateStr.length !== 8) return "";
      const year = dateStr.substring(0, 4);
      const month = dateStr.substring(4, 6);
      const day = dateStr.substring(6, 8);
      return `${day}-${month}-${year}`;
    },
    formatDateFromYYYYMMDD_pdf(dateStr) {
      if (!dateStr || dateStr.length !== 8) return "";
      const year = dateStr.substring(0, 4);
      const month = dateStr.substring(4, 6);
      const day = dateStr.substring(6, 8);
      return `${year}-${month}-${day}`;
    },
    async Getdata() {
      // ตัวอย่างดึงข้อมูลจาก store (หรือ API)
      console.log(this.startDate);
      try {
        const jwt = JSON.parse(localStorage.getItem("company_jwt"));
        const formatDate = (dateObj) => {
          if (typeof dateObj === 'string') {
            dateObj = new Date(dateObj);
          }
          if (!(dateObj instanceof Date) || isNaN(dateObj)) return "";
          const day = String(dateObj.getDate()).padStart(2, "0");
          const month = String(dateObj.getMonth() + 1).padStart(2, "0");
          const year = String(dateObj.getFullYear());
          return `${day}-${month}-${year}`;
        };

        const startStr = formatDate(new Date(this.startDate));
        const endStr = formatDate(new Date(this.endDate));


        const [dayExit, monthExit, yearExit] = startStr.split("-");
        const [dayEntry, monthEntry, yearEntry] = endStr.split("-");

        let params = {
          userId: jwt.userId,
          includeCompany: 'true',
          startDate: `${yearExit}${monthExit}${dayExit}`,
          endDate: `${yearEntry}${monthEntry}${dayEntry}`,
          emptyStationName: 'true',
          _page: this.currentPage,
          _limit: this.perPage,
          _sort: "-1",
        };

        if (this.formUser.alCode && this.formUser.alCode.trim() !== "") {
          params.alcode = this.formUser.alCode;
        }
        if (this.selectedBorder && this.selectedBorder.trim() !== "") {
          params.stationName = this.selectedBorder;
        }
        console.log("Request Params", params);

        const res = await axios.get(`${API}entry`, {
          params,
          headers: {
            Authorization: await store.dispatch("getAuthorization"),
          },
        });
        console.log("API Response", res.data.message.data);


        if (!res.data.message.data || !res.data.message.total) {
          this.items = [];
          this.totalRows = 0;
          return;
        }

        const results = await Promise.all(
          res.data.message.data.map(async (item, index) => {
            const date = new Date(item.createdAt);
            const formattedDate = `${String(date.getDate()).padStart(2, '0')}-${String(date.getMonth() + 1).padStart(2, '0')}-${date.getFullYear()}`;
            console.log("Item UserId:", item.userId);
            const datausername = await this.getDatauserFromCompany(item.userId); // <- เรียก async ได้
            console.log("datausername", datausername);
            return {
              ...item,
              no: index + 1,
              createdAtFormatted: formattedDate,
              Nationality: datausername ? datausername.nationality : '',
              shift: datausername ? datausername.shift : '',
              registeredEntryDateFormatted: this.formatDateFromYYYYMMDD(item.registeredExitDate),
              formatDateFromYYYYMMDD_pdf: this.formatDateFromYYYYMMDD_pdf(item.registeredExitDate),
              _selected: false,
              // datausername, // <- ใส่ข้อมูลที่ได้จาก async ไปใน object
              cardSerialNumber: datausername ? datausername.cardSerialNumber : '',
              prefix: datausername ? datausername.prefix : '',
              firstname: datausername ? datausername.firstname : '',
              lastname: datausername ? datausername.lastname : '',
              gender: datausername ? datausername.gender : '',
            };
          })
        );
        // const results = res.data.message.data.map((item, index) => {
        //   const date = new Date(item.createdAt);
        //   const formattedDate = `${String(date.getDate()).padStart(2, '0')}-${String(date.getMonth() + 1).padStart(2, '0')}-${date.getFullYear()}`;
        //   // const datausername = await getDatauserFromCompany()
        //   return {
        //     ...item,
        //     no: index + 1, // ลำดับเริ่มที่ 1
        //     createdAtFormatted: formattedDate,
        //     _selected: false, // เพิ่มให้ทุกแถวมี property นี้
        //   };
        // });

        console.log(results);
        this.items = results;
        this.totalRows = res.data.message.total;
      } catch (err) {
        console.error("❌ Error:", err.response?.data || err.message);
      } finally {
        this.isBusy = false;
      }
      return;
    },
    async getDataSelectOption() {
      const jwt = JSON.parse(localStorage.getItem("company_jwt"));
      try {
        const res = await axios.get(`${API}config?userId=${jwt.userId}`);
        console.log("✅ success");
        const responseData = res.data.message.data;

        // แปลงข้อมูลให้ตรงกับรูปแบบ dropdown
        const dynamicOptions = responseData.map((item) => ({
          value: item.stationName, // สมมติ field ชื่อ borderName
          text: item.stationName,
        }));

        // รวม option แรก + ตัวเลือกจาก API
        this.options = [{ value: null, text: "-- เลือกด่านชายแดน --" }, ...dynamicOptions];
      } catch (err) {
        if (err.response) {
          console.error("❌ API Error:", err.response.status);
          console.error("Response:", err.response.data);
        } else {
          console.error("❌ Error:", err.message);
        }
      }
    },
    async getDataTable() {

      const dd = await store.getters.getChang;
      //   const dd = await this.$store.dispatch("data_addqueue");
      console.log(dd);
      if (!dd || !dd.length) {
        // console.error("No data available");
        this.itemsdata = [];
        this.totalRows = 0;
        return;
      }
      this.items = dd[0];
      this.itemsdata = dd[0];
      this.totalRows = dd[0].length;
      return


      this.isBusy = true;
      try {
        const jwt = JSON.parse(localStorage.getItem("company_jwt"));

        const params = {
          companyId: jwt.companyId,
          userIdRule: jwt.userId,
          startDate: "2024-07-01",
          endDate: "2025-07-21",
          _page: this.currentPage,
          _limit: this.perPage,
          _sort: "-1",
        };

        const res = await axios.get(`${API}SearchLog`, {
          params,
          headers: {
            Authorization: await store.dispatch("getAuthorization"),
          },
        });

        console.log("API Response", res.data.message);
        console.log("API Response totalRows", res.data.message.total);
        this.itemsdata = res.data.message.data;
        this.totalRows = res.data.message.total;
      } catch (err) {
        console.error("❌ Error:", err.response?.data || err.message);
      } finally {
        this.isBusy = false;
      }
    },
    async handlePageChange(page) {
      console.log(page);
      this.currentPage = page;
      this.items = [];

      await this.Getdata();
    },
    async handleItemsPerPageChange() {
      this.items = [];
      this.currentPage = 1;
      await this.Getdata();
    },
  },
};
</script>